module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABOklEQVQ4jc3UPUvDQACA4bfnBxJrEqUoCIJW1EEwiA4BByEUHXTSTQLSxc1NROjkUsTVzcn2B2QRl+CgTg5COwYUdCrolPRDxEEdouKQ2EYj+I5H7rnccVwia1UAxoA9IAPIRKsKnAI7wHU7MAFcAmpE6CMZWAEMQBdA/hfY11QgL/C3GVcLguhn9l1JESMGwP8Bl8aTHCwPxAMaaYnVyR7sm0Zr4MxgVyg2PyxhagqFksexU28N3JhV2V/sD/yz9WmFo5LH+d1j4IKB4Lb9QEpqY9dIfY5lRrsxNYVi2eMiBAsFvacXNk/uGVI62Jrrw0hLrE3JFMseZ7fhWCgI0Hj20ZHeTkxN4fDKbYoBJLJW5bXpVxH6k4tdjdGrC/zHMa5sAeQANwbMBXICcAAdsIDaD6Da+1wdcN4A7kpKwcUnkAQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/courier/select.png
// module id = 33x9
// module chunks = 3